import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

export default class Rut extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    field: PropTypes.object
  }

  state = { valid: true }

  onInputChange(event) {
    if (event.length < 3) {
      this.setState({ valid: false })
      this.props.onChange(event)
      return
    }
    var numbers = event.replace(/[^\dkK]/g, '')
    this.validate(numbers)
    var parts = numbers.split('')
    if (parts.length === 0) return numbers
    var last = parts.pop()
    if (parts.length === 0) return numbers
    var final = numeral(parts.join('')).format('0,0') + '-' + last
    final = final.replace(/,/g, '.')
    this.props.onChange(final)
  }

  validate(valor) {
    valor = valor.replace('-', '')
    let cuerpo = valor.slice(0, -1)
    let dv = valor.slice(-1).toUpperCase()
    if (cuerpo.length < 7) {
      return false
    }
    let suma = 0
    let multiplo = 2
    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i)
      suma = suma + index
      if (multiplo < 7) {
        multiplo = multiplo + 1
      } else {
        multiplo = 2
      }
    }
    let dvEsperado = 11 - suma % 11
    dv = dv === 'K' ? 10 : dv
    dv = dv === 0 ? 11 : dv
    if (String(dvEsperado) !== String(dv)) {
      this.setState({ valid: false })
      return false
    }
    this.setState({ valid: true })
    return true
  }

  messageField() {
    if (!this.state.valid) {
      return 'Campo sin datos o con datos incorrectos para el rut.'
    } else {
      return 'Todo se ve bien'
    }
  }

  render() {
    return (
      <div className={styles.osInputContainer}>
        <Tooltip content={this.messageField()}>
          <input
            maxLength="12"
            type="text"
            className={
              this.state.valid ? styles.osInputText : styles.osInputTextW
            }
            placeholder={'Rut'}
            value={this.props.value ? this.props.value : ''}
            onChange={event => this.onInputChange(event.target.value)}
          />
        </Tooltip>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/Rut/index.js